import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-bordered-icon-card',
  templateUrl: './bordered-icon-card.component.html',
  styleUrls: ['./bordered-icon-card.component.css']
})
export class BorderedIconCardComponent {
  @Input() data: any;
}
